import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

export class asignaciones{
  institution_id?: String;
  questionaryId?: Number;
  due_date?: String;
  start_date?: String;
  responsible_full_name?: String;
  responsible_role?: String;
  responsible_email?: String;
}

@Injectable({
  providedIn: 'root'
})
export class AsignacionesService {
  private apiURL = environment.api_cuestionariosA_rest;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  
  constructor(
    private cookieService: CookieService,
    private http: HttpClient
  ) {}

  public postAsignaciones(asignacion){
    var as: asignaciones = {
      institution_id: ''+asignacion.inst,
      questionaryId: asignacion.cuesAsigId,
      due_date: (new Date(asignacion.fechaFin)).toISOString(),
      start_date: (new Date(asignacion.fechaIni)).toISOString(),
      responsible_full_name: asignacion.responsable,
      responsible_role: asignacion.cargo,
      responsible_email: asignacion.correo
    }
    const body = JSON.stringify(as);
    const apiURL = this.apiURL + 'allocation';
    return this.http.post(`${apiURL}`, body, {headers: this.headers});
  }
  public patchAsignaciones(asignacion){
    var as: asignaciones = {
      due_date: (new Date(asignacion.fechaFin)).toISOString(),
    }
    const body = JSON.stringify(as);
    const apiURL = this.apiURL + 'allocation/'+asignacion.id;
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }
  /**
   * Registra el total de encuestas enviadas por correo de una asignación. Es un
   * dato manual: nadie lo calcula, lo captura el usuario. Reutiliza el PATCH de
   * la asignación, que acepta el cuerpo parcial.
   * `null` borra la captura (distinto de 0, que sí es un valor capturado).
   */
  public patchEncuestasEnviadas(id, total: number | null){
    const body = JSON.stringify({ sent_surveys_count: total });
    const apiURL = this.apiURL + 'allocation/'+id;
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }

  public deleteAsignaciones(id){
    const apiURL = this.apiURL + 'allocation/'+id;
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }

  /** Cambia el estatus de una asignación (AllocationStatus: 'open' | 'closed') */
  public changeStatusAsignacion(id, status){
    const body = JSON.stringify({ status });
    const apiURL = this.apiURL + 'allocation/change-status/'+id;
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }

  public getHash(idInstitution){
    const apiURL = this.apiURL + 'anonymous-responses/hash?institution_hash='+idInstitution;
    //const apiURL = "https://dev.api.survey.aleema.friedrichlatam.com/api/v1/anonymous-responses/hash?institution_hash="+idInstitution;
    return this.http.get(`${apiURL}`, {headers: this.headers});
  }

  /**
   * Token de una asignación (allocation). Sirve para desambiguar la ronda en el
   * link público (query param `a`), sin exponer el allocationId crudo. El hash de
   * institución (getHash) se mantiene aparte para catálogos.
   */
  public getAllocationToken(allocationId){
    const apiURL = this.apiURL + 'anonymous-responses/allocation-token?allocation_id='+allocationId;
    return this.http.get(`${apiURL}`, {headers: this.headers});
  }

}
